<template>
    <div class="container demo-color-selection" ref="refColor">
        <section class="orders-header">
            <h1 class="titlePage titlePage_textLeft">{{getUserName}}</h1>

            <breadcrumbs v-if="!isEdit"></breadcrumbs>

        </section>

        <section>
            <div ref="searchRef">
                <h2 class="titlePage titlePage_subtitle titlePage_mb">SELECT FRAME COLOUR</h2>
                <div class="row">
                    <div class="col-12 col-md-6" ref="searchInputRef">
                        <form action="" class="form" v-on:submit.prevent >
                            <label class="form__label">
                                <input type="text" class="form__input"
                                    placeholder="Type to Search"
                                    name="search color"
                                    v-model="color"
                                    @focus="complete"
                                    ref="searchInput"
                                >
                            </label>
                            <button type="button" class="btn_link">
                                <font-awesome-icon icon="search"/>
                            </button>
                        </form>
                    </div>
                    <div class="col-12 col-md-6" v-if="showTextHelper">
                        <span class="tw-flex tw-h-full tw-items-center tw-text-primary"><svg-icon name="solid/arrow-left" class="tw-hidden md:tw-block tw-mr-4"/>  Type Pearl White in the Search Bar</span>
                    </div>
                </div>
            </div>

            <div class="divider">
                <p class="divider__text text_green">OR SELECT BELOW</p>
            </div>
            
        </section>
        <section class="item-types">
            <div class="row"
                 v-for="(item, key, index) in colors"
                 :id="`colour-${kebabCase(key)}`"
            >
                <div class="col-12">
                    <h2 class="titlePage_subtitle titlePage">{{key}}</h2>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6"
                     v-for="color in item.colours"
                     :key="color.id"
                     @click="selectColors(color, item, key)"
                >
                    <div class="box">
                        <div class="colours colour_box">
                            <v-lazy-image-plugin :src="color.image" v-if="color.image"/>
                            <p v-else-if="color.hexcode">
                                <font-awesome-icon class="large_icon box__img" :style="{color: color.hexcode}"
                                                   icon="palette"/>
                            </p>
                            <p v-if="!color.image && !color.hexcode">
                                <font-awesome-icon class="large_icon box__img" icon="palette"/>
                            </p>
                        </div>
                        <p class="text_default">{{color.colour_name}}</p>
                    </div>
                </div>
                <div class="tw-px-2 tw-my-4 sm:tw-my-0" v-if="kebabCase(key) === kebabCase('DEFAULT') && item.colours.length">
                    <span class="tw-flex tw-h-full tw-items-center tw-text-primary"><svg-icon name="solid/arrow-left" class="tw-hidden sm:tw-block tw-mr-4"/>  Click a colour to select</span>
                </div>
            </div>
        </section>

        <div class="modal modal_wrap" v-if="warning">
            <div class="modal_popup">
                <p class="text text_white">Chosen colour requires additional price. Please, click "I Accept" button if
                    you want to continue.</p>
                <div class="justify-content-between">
                    <button class="btn btn_transparent" @click="warning = !warning">Cancel</button>
                    <button class="btn btn_transparent" @click="accept">I Accept</button>
                </div>
            </div>
        </div>
        
        <div class="tw-hidden">
            <div ref="stepOneContainer" class="">
                <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
                    <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
                        <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                            FRAME COLOURS
                        </h2>
                        <p>
                            As you can see, we have lots of colours available in our portal.
                        </p>
                    </div>
                    <template v-slot:footer>
                        <div class="tw-mt-4 tw-flex tw-space-x-4">
                            <button @click="goBackToPrevScreen" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                            <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                            </button>

                            <button @click="gotoStandard" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                            <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                            </button>
                        </div>
                    </template>
                </Modal>
            </div>

            <div ref="stepTwoContainer" class="">
                <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
                    <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
                        <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                            FRAME COLOURS
                        </h2>
                        <p>
                            Our most common colours are available in our standard range.
                        </p>
                    </div>
                    <template v-slot:footer>
                        <div class="tw-mt-4 tw-flex tw-space-x-4">
                            <button @click="gotoFirst" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                            <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                            </button>

                            <button @click="gotoNonStandard" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                            <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                            </button>
                        </div>
                    </template>
                </Modal>
            </div>

            <div ref="stepThreeContainer" class="">
                <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
                    <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
                        <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                            FRAME COLOURS
                        </h2>
                        <p>
                            We also offer Non Standard colours. These normally add at least 5 days to the manufacturing process and can incur surcharges.
                        </p>
                    </div>
                    <template v-slot:footer>
                        <div class="tw-mt-4 tw-flex tw-space-x-4">
                            <button @click="backStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                            <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                            </button>

                            <button @click="finalStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                            <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                            </button>
                        </div>
                    </template>
                </Modal>
            </div>

            <div ref="stepFourContainer" class="">
                <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
                    <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
                        <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                            FRAME COLOURS
                        </h2>
                        <p>
                            You can use our search bar to find any colour you need. For the purpose of this demo, we will make our {{type}} frame Pearl White.
                        </p>
                    </div>
                    <template v-slot:footer>
                        <div class="tw-mt-4 tw-flex tw-space-x-4">
                            <button @click="backStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                            <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                            </button>

                            <button @click="finalStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                            <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                            </button>
                        </div>
                    </template>
                </Modal>
            </div>

            <div ref="stepFiveContainer" class="">
            </div>
        </div>
    </div>
</template>

<script>
    import router from "../../router";
    import breadcrumbs from "./../parts/breadcrumbs";
    import {searchColors} from "../../helpers/search";

    import VLazyImagePlugin from "v-lazy-image";
    import GModal from '@/views/pages/demo-wizard/steps/colours/Modal'
    import Modal from '@/components/modals/Generic'
    import VueScrollTo from 'vue-scrollto'
    import asyncDelay from '@/helpers/asyncDelay'

    export default {
        name: "SelectColors",
        props: ['backStepInCreate'],
        data() {
            return {
                color: '',
                warning: false,
                colorItem: {},
                tour: null,
                showTextHelper: false,
            }
        },
        components: {breadcrumbs, VLazyImagePlugin, GModal, Modal},
        beforeDestroy() {
            if(this.tour) this.tour.complete()
        }, 
        methods: {
            async complete() {
                this.$refs.refColor.style.overflow = "unset"
                await asyncDelay(500)
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                this.tour.complete()
                this.$refs.searchInput.focus()
            },
            gotoFirst() {
                let options = {container: '.modal-overflow', easing: 'ease-in', y: true,};
                
                VueScrollTo.scrollTo('.demo-color-selection', 300, options);
                this.tour.back()
            },
            gotoStandard() {
                let options = {container: '.modal-overflow', easing: 'ease-in', y: true,};

                VueScrollTo.scrollTo('#colour-standard', 300, options);
                this.tour.next()
            },
            gotoNonStandard() {
                let options = {container: '.modal-overflow', easing: 'ease-in', y: true,};
                
                VueScrollTo.scrollTo('#colour-non-standard', 300, options);
                this.tour.next()
            },
            goBackToPrevScreen() {
                this.backStepInCreate()
            },
            backStep() {
                if(this.tour.currentStep.id === this.tour.steps[0].id) {
                    this.$store.commit('orderPosition/nextStep', 'Grade');
                }else {
                    this.tour.back()
                }
            },
            kebabCase(val) {
                return _.kebabCase(val)
            },
            nextStep() {
                this.tour.next()
            },
            finalStep() {
                let options = {container: '.modal-overflow', easing: 'ease-in', y: true,};
                
                VueScrollTo.scrollTo('.demo-color-selection', 300, options);

                this.tour.next()
                this.showTextHelper = true
            },
            startTour() {
                if(this.tour) this.tour.complete()
                this.$nextTick(() => {
                    this.tour = this.$shepherd({
                    exitOnEsc: false,
                    useModalOverlay: true,
                    modalOverlayOpeningPadding: 55,
                    arrow: false,
                    // stepsContainer: this.$refs.containerRef,
                    defaultStepOptions: {
                        classes: 'shepherd-theme-custom full-width',
                        arrow: false,
                        modalOverlayOpeningRadius: 10,
                        modalOverlayOpeningPadding: 10, 
                        popperOptions: {
                        modifiers: [{ name: 'offset', options: { offset: [0, 30, ]} }]
                        },
                        beforeShowPromise: async () => {
                            await this.$store.dispatch('demoWizard/delayTransition', 1000)
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'},
                    }
                    });

                    const paths = this.$store.state['demoWizard'].paths
                    const completedPaths = paths.filter(x => x.complete)

                    if(completedPaths.length === 0){
                        this.tour.addStep({
                            text: this.$refs.stepOneContainer,
                        });

                        this.tour.addStep({
                            text: this.$refs.stepTwoContainer,
                        });

                        this.tour.addStep({
                            text: this.$refs.stepThreeContainer,
                        });
                    }

                    this.tour.addStep({
                        attachTo: { element: this.$refs.searchRef, on: 'bottom' },
                        text: this.$refs.stepFourContainer,
                    });

                    this.tour.addStep({
                        attachTo: { element: this.$refs.searchRef, on: 'bottom' },
                        text: this.$refs.stepFiveContainer,
                    });

                    this.tour.start();
                });
            },
            selectColors(target, parent, group) {
                localStorage.setItem('colorGroup', group);
                this.colorItem = target;
                this.$store.commit('orderPosition/setFrameColour', target);

                if (parent.is_show_price_warning) {
                    this.warning = !this.warning;
                }
            },

            accept() {
                this.warning = !this.warning;
                this.$store.commit('orderPosition/setFrameColour', this.colorItem);
            },
        },
        watch: {
            color(n) {
                this.$store.commit('colors/filtered', searchColors(n, this.allColors));
            }
        },
        computed: {
            type() {
                return this.$store.state['demoWizard'].currentPath.name.includes('Door')? 'door': 'window'
            },
            getUserName() {
                return localStorage.getItem('nameUser');
            },
            user() {
                return this.$store.getters['colors/user'];
            },
            allColors() {
                return this.$store.getters['colors/colors'];
            },
            colors() {
                let colours =  this.$store.getters['colors/filtrated']
                let colourList = Object.values(colours).flatMap(i => i.colours)
                let locations =  this.$store.getters['orderPreview/items'].locations
                let orderCoulourIds = Object.values(locations).flatMap(i => (i.items.standard || []).flatMap(k => k.colour_id))
                let defaultColourList = colourList.filter(c => orderCoulourIds.includes(c.id))
                let systemDefaults = colourList.filter(c => {return c.is_system_default && !defaultColourList.includes(c)})
                let defaultColour = { default:{ colours: defaultColourList.concat(systemDefaults), is_show_price_warning: false}}
                return { ...defaultColour, ...colours }
            },
            isEdit() {
                return this.$store.getters['orderPosition/isCompleted']
            },
// >>>>>>> 1195684220473532-add-dimension
        },

        mounted() {
            this.$refs.refColor.style.overflow = "hidden"
            this.$store.dispatch('colors/getColors');
            // this.$store.dispatch('demoWizard/delayTransition')
            // .then(() => {
                this.startTour()
            // })
        },

        created() {
            this.$store.commit('options/cleanOptions');
        },

    }
</script>

<style lang="scss">
    .shepherd-element.full-width {
        width: 100%;
        .modal_popup {
            position: relative;
            left: unset;
            right: unset;
            top: unset;
            bottom: unset;
            transform: unset;
        }
    }
</style>

<style scoped lang="scss">

    @import "../../../src/assets/scss/utils/vars";
    
    .box {
        margin-bottom: 1rem;
        &__img {
            position: static;
            display: block;
            margin: 0 auto;
            margin-bottom: 20px;
            width: 100%;
            max-width: 160px;
            height: 100px;
        }
        p {
            text-align: center;
        }
    }

    .form {
        position: relative;
        .btn_link {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            cursor: pointer;
            svg {
                color: $green;
            }
        }

        &__input {
            padding-right: 40px;
            border: 2px solid #0b3553;
        }

    }

    .justify-content-between {
        display: flex;
    }

</style>
